<template>
    <bar-chart :id="id" :data="dataValue" resize="true" xkey="label" :ykeys="['value']" grid="true" grid-text-weight="bold" :bar-color="['#FF6384']"></bar-chart>
</template>
<script>
    import { BarChart } from 'vue-morris';
    export default {
        props: ['id', 'data', 'colors', 'options'],
        mounted () {
            /*var self = this;
            new Morris.Donut({
                element: self.$el,
                data: this.data,/*[
                    { label: "Abiertas", value: 12 },
                    { label: "Ganadas", value: 30 },
                    { label: "Perdidas", value: 20 }
                ],
                //{this.options},//resize: true,
                colors: this.colors,//['#007bff', '#28a745', '#dc3545'],
            });*/

            //console.log(this.data);
        },
        computed: {
            dataValue(){
                return this.data.map(function(x){
                    return {
                        'FECHA_INICIAL': x.FECHA_INICIAL,
                        'FECHA_FINAL': x.FECHA_FINAL,
                        'label': x.label,
                        'value': x.value
                    }
                })
            }
        },

        components:{
            BarChart
        }
    }
</script>